var _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDarRejected = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 25,
  height: 24,
  viewBox: "0 0 25 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 12.333,
  cy: 12,
  r: 12,
  fill: "url(#paint0_linear_47687_220815)"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12.3327 5.3335C8.66602 5.3335 5.66602 8.3335 5.66602 12.0002C5.66602 15.6668 8.66602 18.6668 12.3327 18.6668C15.9993 18.6668 18.9993 15.6668 18.9993 12.0002C18.9993 8.3335 15.9993 5.3335 12.3327 5.3335ZM14.7993 13.5335C15.066 13.8002 15.066 14.2002 14.7993 14.4668C14.5327 14.7335 14.1327 14.7335 13.866 14.4668L12.3327 12.9335L10.7993 14.4668C10.5327 14.7335 10.1327 14.7335 9.86602 14.4668C9.59935 14.2002 9.59935 13.8002 9.86602 13.5335L11.3993 12.0002L9.86602 10.4668C9.59935 10.2002 9.59935 9.80016 9.86602 9.5335C10.1327 9.26683 10.5327 9.26683 10.7993 9.5335L12.3327 11.0668L13.866 9.5335C14.1327 9.26683 14.5327 9.26683 14.7993 9.5335C15.066 9.80016 15.066 10.2002 14.7993 10.4668L13.266 12.0002L14.7993 13.5335Z",
  fill: "white"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_47687_220815",
  x1: 6.83301,
  y1: 1,
  x2: 16.333,
  y2: 23,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#CFC1ED"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#A0DDFF"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgDarRejected);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/dar_rejected.96ce23b47a21be42710bffccf2cc419c.svg";